module.exports = __webpack_public_path__ + "static/img/banner-191202-honeymoon.f103e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-191202-honeymoon.png
// module id = /v3a
// module chunks = 1